<template>
  <el-scrollbar :class="isUsing ? 'h-[calc(100%-60px)]' : 'h-[calc(100%-24px)]'">
    <set-agent />
    <base-info />
    <business-license-info class="business-info" />
    <legal-person-info class="person-info" />
    <licence-info v-if="isCompanyEnterpise" class="licence-info" />
    <bingding-card-info v-if="!isCompanyEnterpise" class="bingding-card-info" />
    <company-introduction class="company-info" />
    <div class="tips">
      <div class="title">
        温馨提示
      </div>
      <div class="item">
        1、银行预留的企业信息变更，请及时联系交付处理，否则可能影响交易。
      </div>
      <div class="item">
        2、绑定手机号用于资金操作时验证码校验。
      </div>
    </div>
  </el-scrollbar>
</template>

<script setup lang="ts">
import { 
  CompanySetAgent as SetAgent,
  CompanyBaseInfo as BaseInfo,
  CompanyBusinessLicenseInfo as BusinessLicenseInfo,
  CompanyLegalPersonInfo as LegalPersonInfo,
  CompanyBindingCardInfo as BingdingCardInfo,
  CompanyLicenceInfo as LicenceInfo,
  CompanyCompanyIntroduction as CompanyIntroduction,
} from '@core/main';
import { computed, inject } from 'vue';
import { ECompanyType } from '@core/main/types';
import { useRoute } from 'vue-router';

defineOptions({ name: 'AgentBaseInfoTab' }); // 账户中心 - 企业管理详情 - 基本信息

const route = useRoute();

const isCompanyEnterpise = computed(() => route.query.companyType === ECompanyType.Company);

const isUsing = inject('isUsing') as boolean;
</script>

<style lang="scss" scoped>
.tips {
  margin: 24px 0 0 24px;
  padding-bottom: 32px;

  .title {
    font-size: 14px;
    color: #344767;
    margin-bottom: 8px;
  }

  .item {
    color: #6B7891;
    font-size: 12px;
  }
}
</style>
